import { parseMessengerFileSizeBytes } from '@/utils/messengerMessageNormalize';

const UNITS = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'] as const;

/** Человекочитаемый размер (русские единицы), в духе ProjectFilesPopover. */
export function formatFileSizeRu(bytes: number): string {
  if (bytes === 0) return '0 Б';
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1);
  if (i === 0) return `${bytes} ${UNITS[0]}`;
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${UNITS[i]}`;
}

/** Допускает number и string (BIGINT из API). */
export function formatFileSizeRuOptional(bytes: number | string | null | undefined): string | null {
  const n = parseMessengerFileSizeBytes(bytes);
  if (n == null) return null;
  return formatFileSizeRu(n);
}
